<template>
  <div>
    <div class="search">
      <md-field md-clearable :class="{ 'md-invalid': noHits }">
        <!-- <gl-icon-search /> -->
        <label>商品コード</label>
        <md-input
          ref="text"
          type="text"
          :value="item.code"
          @change="inputCode"
        ></md-input>
        <span class="md-error">商品が見つかりませんでした</span>
      </md-field>
      <div class="">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'
/**
 * 商品選択コンポーネント
 */
export default {
  components: {},
  mixins: [ErrorReport],
  props: {
    /**
     * 企業コード
     */
    company: {
      type: String,
    },
    /**
     * 分析対象商品
     */
    item: {
      type: Object,
      default: () => ({
        code: '',
        name: '',
      }),
    },
  },
  data() {
    return {
      /**
       * 前回選択企業
       */
      lastCompany: undefined,
      /**
       * 検索テキストでのヒットなし
       */
      noHits: false,
    }
  },
  computed: {
    errors() {
      const errors = []

      if (!this.item.name) {
        errors.push('商品を入力してください')
      }
      return errors
    },
  },
  methods: {
    /**
     * コード入力
     */
    async inputCode(e) {
      const itemCode = e.target.value
      this.item.name = ''

      if (itemCode) {
        const results = await this.$repositories
          .get('item')
          .getByCode(this.company, [itemCode])

        if (results && results.length > 0) {
          // this.item = results[0].name
          this.$emit('update:item', results[0])
        }
        this.noHits = results.length === 0
      }
    },
  },
  watch: {
    company: {
      immediate: true,
      async handler(company) {
        if (company && this.lastCompany && company !== this.lastCompany) {
          this.$emit('update:item', { code: '', name: '' })
        }
        this.lastCompany = company
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
